const Getters = {
  getCombinedBillListFromState: (state) => {
    return state.combinedBillList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
